@import (reference) '../../../../constants/spacing.module.less';

.icon {
  height: 100%;
  width: 100%;
}

.icon-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--default--icon-button--fill-color--1);
  padding: @space-4;
  border-radius: 4px;
  height: 24px;
  min-height: 24px;
  width: 24px;
  min-width: 24px;

  &:focus-visible {
    background: var(--default--icon-button--focus--background-color-1);

    outline: solid 1px var(--primary--focus--border-color--3);
    outline-offset: -1px;
  }

  &:enabled {
    &:hover {
      background: var(--default--icon-button--hover--background-color-1);
    }

    &:active {
      background: var(--default--icon-button--active--background-color-1);
    }
  }

  &:disabled {
    color: var(--default--icon-button--disabled--fill-color-1);
    cursor: default;
  }
}

.button-active {
  background: var(--default--icon-button--active--background-color-1);
}
